import directive from './directive'

export default {
  install: function(Vue, options) {

    Vue.directive('dominantColor', directive);
  }
}


// WEBPACK FOOTER //
// ./src/plugins/dominant-color/index.js